var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 26,
    viewBox: "0 0 44 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4100_5022)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4100_5022",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V26H44V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4100_5022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.425728 5.61738C3.49176 11.7842 6.5578 17.951 9.62381 24.1179C11.7465 28.3875 18.0934 24.6383 15.9752 20.3834L6.77968 1.88228C4.6564 -2.38675 -1.68992 1.36303 0.428269 5.61738H0.425728Z",
    fill: "#002EE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62382 5.61738C12.6903 11.7842 15.7566 17.951 18.8226 24.1179C20.9445 28.3875 27.2928 24.6383 25.174 20.3834C22.1101 14.2161 19.0448 8.04907 15.9784 1.88228C13.8558 -2.38675 7.50882 1.36303 9.62704 5.61738H9.62382Z",
    fill: "#002EE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.823 5.61738C21.8887 11.7842 24.9547 17.951 28.0212 24.1179C30.1438 28.3875 36.4914 24.6383 34.3726 20.3834C31.3091 14.2161 28.2438 8.04907 25.177 1.88228C23.055 -2.38675 16.7067 1.36303 18.8256 5.61738H18.823Z",
    fill: "#002EE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0211 5.61738C31.0876 11.7842 34.1536 17.951 37.2192 24.1179C39.3418 28.3875 45.6894 24.6383 43.5706 20.3834C40.5075 14.2161 37.4426 8.04907 34.3756 1.88228C32.253 -2.38675 25.9061 1.36303 28.0211 5.61738Z",
    fill: "#002EE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2198 1.88228C34.1542 8.04907 31.0879 14.2161 28.0211 20.3834C25.9061 24.6383 32.253 28.3875 34.3756 24.1179C37.4412 17.9514 40.5073 11.7846 43.5737 5.61738C45.6894 1.36303 39.3418 -2.38675 37.2223 1.88228H37.2198Z",
    fill: "#002EE0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4100_5022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxLogo);
export default __webpack_public_path__ + "static/media/wx-logo.1d73a795f70b255a62c5b3dbb2920dd5.svg";
export { ForwardRef as ReactComponent };